import { useContext } from "react";

// Context
import AlertContext from "../../context/AlertContext";

// Custom styles
import "./alert.styles.scss";

const Alert = () => {
  const alert = useContext(AlertContext);

  if (alert.alert !== "") {
    return (
      <div
        className={`alert ${alert.alert === "Success" ? "alert-success" : "alert-danger"
          }`}
      >
        <div className="alert-content">
          {alert.alertText}
        </div>
        <button
          className="alert-close"
          onClick={alert.clear}
          aria-label="Cerrar alerta"
        >
          ×
        </button>
      </div>
    );
  } else {
    return null;
  }
};

export default Alert;
